import { Reducer } from 'redux';
import { OfferActionTypes, OffersState } from './types';

const initialState: OffersState = {
  activeOffer: null
};

const reducer: Reducer<OffersState> = (state = initialState, action) => {
  switch (action.type) {
    case OfferActionTypes.GET_ACTIVE_OFFERS_SUCCESS:
      return {
        ...state,
        offers: action.payload.offers
      };
    case OfferActionTypes.GET_ACTIVE_OFFERS_FAILURE:
      return {
        ...state,
        offers: []
      };
    case OfferActionTypes.SET_ACTIVE_OFFER:
      return {
        ...state,
        activeOffer: action.payload
      };
    default:
      return state;
  }
};

export { reducer as offersReducer };
